/**
 * Markdown 渲染：markdown-it 关闭原始 HTML，输出再经 DOMPurify 清洗
 */
import MarkdownIt from 'markdown-it'
import DOMPurify from 'dompurify'

export const markdown = new MarkdownIt({ html: false, breaks: true, linkify: false })

export function renderMarkdown(source: string, inline = false): string {
  const trimmed = (source || '').trim()
  if (!trimmed) return ''
  return DOMPurify.sanitize(inline ? markdown.renderInline(trimmed) : markdown.render(trimmed))
}
